$(document).ready(function () {
  $(document).on("click", ".img-description-banner__info", function () {
    $(this)
      .find(".img-description-banner__info__tooltip")
      .toggleClass("show_tooltip");
    $(this).parents(".img-description-banner").toggleClass("tooltip-active");
    console.log("sssss");
  });

  $(".price-rating-wrapper .styled-card__rating").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#judgeme_product_reviews").offset().top,
      },
      2000
    );
  });

  $("#back-to-top").click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1000
    );
  });

  $(".product-form__input input[type=radio]+label[data-img]").click(
    function () {
      let img = $(this).attr("data-img");
      let thumbnail = $(this).attr("data-thumbnail");
      console.log("Img: ", img, "Thumbnail: ", thumbnail);
      $(".variant-main-img").find("img").attr("src", img);
      $(".variant-main-img").find("img").attr("srcset", img);
      $("#variant-thumbnail-img").find("img").attr("src", thumbnail);
      swiper2.slideTo(0, 400);
      swiper.slideTo(0, 400);
    }
  );

  $(document).on("click", ".delete-link", function () {
    let link = $(this).attr("data-item-index");
    $(`#CartDrawer-Remove-${link}, #CartDrawer-Remove-${link} button`).click();
    console.log("test");
  });

  window.onscroll = function () {
    scrollFunction();
  };

  function scrollFunction() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      $("#back-to-top").fadeIn();
    } else {
      $("#back-to-top").fadeOut();
    }
  }
});

$(window).scroll(function () {
  clearTimeout($.data(this, "scrollTimer"));
  $.data(
    this,
    "scrollTimer",
    setTimeout(function () {
      // do something
      let ele = document.querySelector(".hidden-container-for-sticky-button");
      let visibility = elementInViewport2(ele);
      console.log(visibility, "visibility");
      if (!visibility) {
        $(".sticky-bottom-button").fadeIn(100);
        if ($(".klaviyo-bis-trigger").length) {
          let clone = $(".klaviyo-bis-trigger").clone();
          $(".sticky-bottom-button__btn-wrapper").append(clone);
        }
      } else {
        $(".sticky-bottom-button").fadeOut(100);
        if (
          $(".sticky-bottom-button__btn-wrapper .klaviyo-bis-trigger").length
        ) {
          $(".sticky-bottom-button__btn-wrapper .klaviyo-bis-trigger").remove();
        }
      }
    }, 50)
  );
});

const screenWidth_s = $(window).width();
let getDirection_s = "vertical";
if (screenWidth_s <= 749) {
  getDirection_s = "horizontal";
}

function elementInViewport2(el) {
  if (!el) {
    return;
  }
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < window.pageYOffset + window.innerHeight &&
    left < window.pageXOffset + window.innerWidth &&
    top + height > window.pageYOffset &&
    left + width > window.pageXOffset
  );
}

function checkingElement(selectorIs, functionName, timer, args = "") {
  try {
    var divCheckingInterval = setInterval(
      function () {
        if (document.querySelector(selectorIs)) {
          clearInterval(divCheckingInterval);
          if (typeof functionName !== "undefined" && functionName) {
            window[functionName](args ? args : "");
          }
          return true;
        }
      },
      timer != "" ? timer : 250
    );
    return false;
  } catch (err) {
    console.log(`ERROR checkingElement`, err.message);
  }
}

async function updateCartItems(updates, cart) {
  const formData = {
    updates: updates,
    sections: cart
      .getSectionsToRender()
      .map((section) => section.id)
      .join(","),
  };

  return fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      cart.renderContents(data);
    })
    .catch((error) => {
      console.error("Failed to update cart:", error);
    });
}

async function changeQuantity(id, quantity, cart) {
  const formData = {
    id: id.toString(),
    quantity: quantity,
    sections: cart
      .getSectionsToRender()
      .map((section) => section.id)
      .join(","),
  };

  return fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      cart.renderContents(data);
    })
    .catch((error) => {
      console.error("Failed to remove products from cart:", error);
    });
}

async function clearCart(cart) {
  return fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({
      sections: cart
        .getSectionsToRender()
        .map((section) => section.id)
        .join(","),
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      cart.renderContents(data);
    })
    .catch((error) => {
      console.error("Failed to clear the cart:", error);
    });
}

class DiscountPromotion extends HTMLElement {
  constructor() {
    super();
    this.clipboardButton = this.querySelector(
      ".discount-promotion__discount-content"
    );
    this.discount = this.querySelector("#discount");
    this.copyIcon = this.querySelector(".icon--copy-icon");
    this.checkIcon = this.querySelector(".icon--check");

    this.init();
  }

  init() {
    this.clipboardButton.addEventListener("click", () => {
      this.copyToClipboard();
    });
  }

  copyToClipboard() {
    navigator.clipboard
      .writeText(this.discount.textContent)
      .then(() => {
        this.copyIcon.classList.add("hidden");
        this.checkIcon.classList.remove("hidden");
        setTimeout(() => {
          this.checkIcon.classList.add("hidden");
          this.copyIcon.classList.remove("hidden");
        }, 2000);
      })
      .catch((err) => {
        console.error("Could not copy text: ", err);
      });
  }
}

// Define the new custom element
customElements.define("discount-promotion", DiscountPromotion);

class DiscountInput extends HTMLElement {
  constructor() {
    super();

    this.applyButton = document.querySelector("#apply-discount-btn");
    this.discountCodeInput = document.querySelector("#discount-code-input");
    this.discountCodeWrapper = document.querySelector(".discount-code-wrapper");
    this.totalCartSelector = document.querySelector(".total-cart");
    this.discountCodeValue = document.querySelector(".discount-code-value");
    this.discountCodeError = document.querySelector(".discount-code-error");
    this.clearButton = document.querySelector("#clear-discount-btn");
    this.toggleButton = this.querySelector(".accordion__toggle");
    this.accordion = this.querySelector(".accordion");
    this.content = this.querySelector(".accordion__content");
    this.discountInformation = this.querySelector(".discount-information");
    this.init();
  }

  init() {
    if (localStorage.getItem("discountCode")) {
      const savedDiscount = JSON.parse(localStorage.getItem("discountCode"));
      this.applyDiscountCode(savedDiscount.code, true);
    }

    if (this.applyButton) {
      this.applyButton.addEventListener("click", (e) => this.handleApply(e));
    }

    if (this.toggleButton) {
      this.toggleButton.addEventListener("click", () => this.toggleAccordion());
    }

    if (this.clearButton) {
      this.clearButton.addEventListener("click", (e) => this.clearDiscount(e));
    }
  }

  toggleAccordion() {
    const isExpanded = this.accordion.getAttribute("aria-expanded") === "true";
    this.accordion.setAttribute("aria-expanded", !isExpanded);
    this.content.hidden = isExpanded;
  }

  handleApply(e) {
    e.preventDefault();
    const code = this.discountCodeInput.value.trim();

    if (code) {
      this.discountCodeInput.style.border = "";
      this.applyDiscountCode(code);
    } else {
      this.discountCodeInput.style.border = "1px solid red";
    }
  }

  applyDiscountCode(code, isInitialLoad = false) {
    this.setLoadingState(true);
    this.discountInformation.removeAttribute("hidden");
    this.discountInformation.textContent = "Code wird geprüft";

    fetch(`/discount/${code}`)
      .then(() => fetch("/cart?view=discount"))
      .then((res) => res.text())
      .then((data) => {
        const dataObject = JSON.parse(data);
        const appliedCodes = dataObject.discounts.map((i) =>
          i.title.toLowerCase()
        );

        if (appliedCodes.includes(code.toLowerCase())) {
          fetch(window.location.pathname + "?sections=cart-drawer")
            .then((res) => res.json())
            .then((res) => {
              const placeholder = document.createElement("div");
              placeholder.innerHTML = res["cart-drawer"];

              document.querySelector("cart-drawer").innerHTML =
                placeholder.querySelector("cart-drawer").innerHTML;

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "cart-items",
                data: dataObject,
              });
            });
        } else {
          this.handleInvalidDiscount();
        }
      })
      .catch(() => {
        if (!isInitialLoad) {
          this.showError("An error occurred. Please try again.");
        }
      })
      .finally(() => this.setLoadingState(false));
  }

  handleInvalidDiscount() {
    if (this.discountInformation) {
      this.discountInformation.classList.add("text--highlight");
      this.discountInformation.textContent = "Falscher Rabattcode";
      setTimeout(() => {
        this.discountInformation.setAttribute("hidden", "");
        this.discountInformation.classList.remove("text--highlight");
      }, 1500);
    }
  }

  setLoadingState(isLoading) {
    if (this.applyButton) {
      this.applyButton.style.pointerEvents = isLoading ? "none" : "all";
      this.applyButton.disabled = isLoading ? true : false;
    }
  }

  clearDiscount(e) {
    e.preventDefault();
    this.clearLocalStorage();
  }

  clearLocalStorage() {
    if (this.discountCodeWrapper)
      this.discountCodeWrapper.style.display = "none";
    if (this.totalCartSelector) {
      const savedDiscount = localStorage.getItem("discountCode");
      if (savedDiscount) {
        this.totalCartSelector.textContent =
          JSON.parse(savedDiscount).totalCart;
      }
    }

    localStorage.removeItem("discountCode");
    if (this.discountCodeValue) this.discountCodeValue.textContent = "";
    if (this.discountCodeError) this.discountCodeError.textContent = "";
  }

  showError(message) {
    if (this.discountCodeError) {
      this.discountCodeError.textContent = message;
    }
  }
}

// Define the custom element
customElements.define("discount-input", DiscountInput);

class CartGoodies extends HTMLElement {
  constructor() {
    super();

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    this.goodiePopover = document.querySelector("#GoodiePopover");
    this.checkoutForms = document.querySelectorAll("#CartDrawer-Form");
    this.allGoodies = this.querySelectorAll("[data-goodie]");

    this.unsubscribeCartUpdate = null;
  }

  get thresholdConsideration() {
    return this.dataset.thresholdConsideration;
  }

  connectedCallback() {
    this.unsubscribeCartUpdate = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        this.handleCartChange(event);
      }
    );

    if (this.goodiePopover) {
      this.checkoutForms.forEach((form) => {
        form.addEventListener("submit", this.handleFormSubmit.bind(this));
      });
    }

    // Initial check on page load
    this.checkGoodieVisibility();
  }

  async checkGoodieVisibility() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const consideration = this.thresholdConsideration.replace(/"/g, '');
      const cartTotal = consideration === "before_discounts"
        ? cart.original_total_price
        : cart.total_price;
      
      const cartItemCount = cart.item_count;

      this.updateGoodieUI(cartTotal, cartItemCount, cart.items);
    } catch (error) {
      console.error('Error checking goodie visibility:', error);
    }
  }

  updateGoodieUI(cartTotal, cartItemCount, cartItems = []) {
    this.allGoodies.forEach((goodie) => {
      const threshold = parseInt(goodie.dataset.threshold);
      const type = goodie.dataset.type;
      const variantId = parseInt(goodie.dataset.variant);
      
      // Skip if no valid type or threshold
      if (!type || !threshold || threshold <= 0) {
        return;
      }
      
      let currentValue = 0;
      let percentage = 0;
      
      if (type === 'price') {
        currentValue = cartTotal;
        percentage = (cartTotal / threshold) * 100;
      } else if (type === 'quantity') {
        // Exclude the goodie item itself from the count
        currentValue = cartItemCount;
        
        // Find if this goodie is in the cart
        const goodieInCart = cartItems.find(item => item.id === variantId);
        if (goodieInCart) {
          currentValue = currentValue - goodieInCart.quantity;
        }
        
        percentage = (currentValue / threshold) * 100;
      } else {
        return; // Unknown type
      }
      
      const atcButton = goodie.querySelector('.cart-item__goodie-atc button');
      const progressBar = goodie.querySelector('.progress-bar__wrapper');
      const progressBarInner = goodie.querySelector('.progress-bar');
      const iconWrapper = goodie.querySelector('.icon-wrapper');

      // Update progress bar
      if (progressBar) {
        const displayPercentage = Math.min(percentage, 100);
        progressBar.style.setProperty('--progress', `${displayPercentage}%`);
      }

      // Update progress bar class
      if (progressBarInner) {
        if (percentage < 100) {
          progressBarInner.classList.add('progress-bar--in-progress');
        } else {
          progressBarInner.classList.remove('progress-bar--in-progress');
        }
      }

      // Update icon wrapper
      if (iconWrapper) {
        if (percentage >= 100) {
          iconWrapper.classList.add('icon-wrapper--success');
          // Replace icon with checkmark if not already
          if (!iconWrapper.querySelector('.icon-checkmark')) {
            iconWrapper.innerHTML = `<svg class="icon icon-checkmark color-foreground-" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"/></svg>`;
          }
        } else {
          iconWrapper.classList.remove('icon-wrapper--success');
          // Replace icon with present if not already
          if (!iconWrapper.querySelector('svg[width="14"][height="14"]')) {
            iconWrapper.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M12.7695 3.28125H11.1004C11.3585 2.93825 11.5117 2.5121 11.5117 2.05078C11.5117 0.91998 10.5917 0 9.46094 0C8.77978 0 8.2775 0.244043 7.88022 0.768004C7.54786 1.20638 7.30483 1.81844 7 2.59178C6.69517 1.81841 6.45214 1.20638 6.11978 0.768004C5.7225 0.244043 5.22022 0 4.53906 0C3.40826 0 2.48828 0.91998 2.48828 2.05078C2.48828 2.5121 2.64149 2.93825 2.89956 3.28125H1.23047C0.551988 3.28125 0 3.83324 0 4.51172V5.33203C0 5.86674 0.342918 6.32264 0.820312 6.49195V12.7695C0.820312 13.448 1.3723 14 2.05078 14H11.9492C12.6277 14 13.1797 13.448 13.1797 12.7695V6.49195C13.6571 6.32264 14 5.86674 14 5.33203V4.51172C14 3.83324 13.448 3.28125 12.7695 3.28125ZM7.75288 2.91867C8.38122 1.32459 8.62009 0.820312 9.46094 0.820312C10.1394 0.820312 10.6914 1.3723 10.6914 2.05078C10.6914 2.72926 10.1394 3.28125 9.46094 3.28125H7.60941C7.65967 3.15506 7.7076 3.03357 7.75288 2.91867ZM4.53906 0.820312C5.37991 0.820312 5.61879 1.32459 6.24712 2.91867C6.2924 3.03357 6.34033 3.15506 6.39059 3.28125H4.53906C3.86058 3.28125 3.30859 2.72926 3.30859 2.05078C3.30859 1.3723 3.86058 0.820312 4.53906 0.820312ZM5.35938 13.1797H2.05078C1.82462 13.1797 1.64062 12.9957 1.64062 12.7695V6.5625H5.35938V13.1797ZM5.35938 5.74219H1.23047C1.00431 5.74219 0.820312 5.55819 0.820312 5.33203V4.51172C0.820312 4.28556 1.00431 4.10156 1.23047 4.10156H5.35938V5.74219ZM7.82031 13.1797H6.17969V4.10156C6.26563 4.10156 7.34891 4.10156 7.82031 4.10156V13.1797ZM12.3594 12.7695C12.3594 12.9957 12.1754 13.1797 11.9492 13.1797H8.64062V6.5625H12.3594V12.7695ZM13.1797 5.33203C13.1797 5.55819 12.9957 5.74219 12.7695 5.74219H8.64062V4.10156H12.7695C12.9957 4.10156 13.1797 4.28556 13.1797 4.51172V5.33203Z" fill="white"/></svg>`;
          }
        }
      }

      // Update button state and text
      if (atcButton) {
        // Save spinner element reference before clearing
        const spinnerHTML = atcButton.querySelector('.loading-overlay__spinner')?.outerHTML || '';
        
        if (percentage < 100) {
          atcButton.disabled = true;
          
          // Clear button content
          atcButton.innerHTML = '';
          
          // Add lock icon
          const lockIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          lockIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
          lockIcon.setAttribute('width', '14');
          lockIcon.setAttribute('height', '18');
          lockIcon.setAttribute('viewBox', '0 0 14 18');
          lockIcon.setAttribute('fill', 'none');
          lockIcon.innerHTML = '<path d="M7.00138 0.529297C4.35432 0.529297 2.23667 2.64694 2.23667 5.294V7.41165C1.33667 7.41165 0.648438 8.09988 0.648438 8.99988V15.8822C0.648438 16.7822 1.33667 17.4705 2.23667 17.4705H11.7661C12.6661 17.4705 13.3543 16.7822 13.3543 15.8822V8.99988C13.3543 8.09988 12.6661 7.41165 11.7661 7.41165V5.294C11.7661 2.64694 9.64844 0.529297 7.00138 0.529297ZM12.2955 8.99988V15.8822C12.2955 16.1999 12.0837 16.4116 11.7661 16.4116H2.23667C1.91903 16.4116 1.70726 16.1999 1.70726 15.8822V8.99988C1.70726 8.68224 1.91903 8.47047 2.23667 8.47047H2.76608H11.2367H11.7661C12.0837 8.47047 12.2955 8.68224 12.2955 8.99988ZM3.2955 7.41165V5.294C3.2955 3.2293 4.93667 1.58812 7.00138 1.58812C9.06608 1.58812 10.7073 3.2293 10.7073 5.294V7.41165H3.2955Z" fill="white"/><path d="M7.0023 10.0586C6.1023 10.0586 5.41406 10.7468 5.41406 11.6468C5.41406 12.3351 5.83759 12.9174 6.47289 13.1292V14.2939C6.47289 14.6115 6.68465 14.8233 7.0023 14.8233C7.31994 14.8233 7.53171 14.6115 7.53171 14.2939V13.1292C8.167 12.9174 8.59053 12.3351 8.59053 11.6468C8.59053 10.7468 7.9023 10.0586 7.0023 10.0586ZM7.0023 12.1762C6.68465 12.1762 6.47289 11.9645 6.47289 11.6468C6.47289 11.3292 6.68465 11.1174 7.0023 11.1174C7.31994 11.1174 7.53171 11.3292 7.53171 11.6468C7.53171 11.9645 7.31994 12.1762 7.0023 12.1762Z" fill="white"/>';
          atcButton.appendChild(lockIcon);
          
          // Add text
          const textSpan = document.createElement('span');
          if (type === 'price') {
            const thresholdMoney = this.formatMoney(threshold);
            textSpan.textContent = `Gratis ab ${thresholdMoney}`;
          } else if (type === 'quantity') {
            textSpan.textContent = `Gratis ab ${threshold} Artikeln`;
          }
          atcButton.appendChild(textSpan);
          
          // Re-add spinner from saved HTML
          if (spinnerHTML) {
            atcButton.insertAdjacentHTML('beforeend', spinnerHTML);
          }
        } else {
          atcButton.disabled = false;
          
          // Clear button content
          atcButton.innerHTML = '';
          
          // Add text
          const textSpan = document.createElement('span');
          textSpan.textContent = 'Hinzufügen';
          atcButton.appendChild(textSpan);
          
          // Re-add spinner from saved HTML
          if (spinnerHTML) {
            atcButton.insertAdjacentHTML('beforeend', spinnerHTML);
          }
        }
      }
    });
  }

  formatMoney(cents) {
    const euros = cents / 100;
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(euros);
  }

  disconnectedCallback() {
    if (this.unsubscribeCartUpdate) {
      this.unsubscribeCartUpdate();
      this.unsubscribeCartUpdate = null; // Clear the reference
    }

    if (this.goodiePopover) {
      this.checkoutForms.forEach((form) => {
        form.removeEventListener("submit", this.handleFormSubmit.bind(this));
      });
    }
  }

  handleFormSubmit(event) {
    if (event.submitter.id !== "CartDrawer-Checkout--new") {
      return;
    }

    event.preventDefault();
    this.openPopover();
  }

  openPopover() {
    this.goodiePopover.setAttribute("aria-expanded", true);
    this.goodiePopover.setAttribute("open", "");
  }

  closePopover() {
    this.goodiePopover.setAttribute("aria-expanded", false);
    this.goodiePopover.removeAttribute("open");
  }

  async handleCartChange(event) {
    if (!event?.data) return;

    const cartItems = event.data.items;
    
    // Parse thresholdConsideration (remove quotes if JSON stringified)
    const consideration = this.thresholdConsideration.replace(/"/g, '');
    const cartTotal =
      consideration === "before_discounts"
        ? event.data.original_total_price
        : event.data.total_price;
    const cartItemCount = event.data.item_count;
    const updates = {}; // Store all cart updates (id -> quantity)
    let allGoodiesInCart = true;

    // Update all goodie UI elements based on new cart total and item count
    this.updateGoodieUI(cartTotal, cartItemCount, cartItems);

    this.allGoodies.forEach((goodie) => {
      const id = parseInt(goodie.dataset.variant);
      const threshold = parseInt(goodie.dataset.threshold);
      const type = goodie.dataset.type;

      // Skip if no valid configuration
      if (!type || !threshold || threshold <= 0) {
        return;
      }

      const goodieItem = cartItems.find((item) => item.id === id);

      if (!goodieItem) {
        allGoodiesInCart = false;
        return;
      }

      let shouldRemove = false;
      if (type === 'price') {
        shouldRemove = cartTotal < threshold;
      } else if (type === 'quantity') {
        // Exclude the goodie item itself from the count when checking threshold
        const itemCountWithoutGoodie = cartItemCount - goodieItem.quantity;
        shouldRemove = itemCountWithoutGoodie < threshold;
      }

      // Ensure quantity is max 1
      if (goodieItem.quantity > 1) {
        updates[id] = 1;
      }

      // Remove if below threshold
      if (shouldRemove) {
        updates[id] = 0;
      }
    });

    // If only goodies are in the cart, clear it
    if (allGoodiesInCart && cartItems.length === this.allGoodies.length) {
      clearCart(this.cart);
      return;
    }

    // Perform update if there are changes
    if (Object.keys(updates).length > 0) {
      await updateCartItems(updates, this.cart);
    }
  }
}

customElements.define("cart-goodies", CartGoodies);

class AtcButton extends HTMLElement {
  constructor() {
    super();
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    this.submitButton = this.querySelector("button")
      ? this.querySelector("button")
      : this;
  }

  get variantId() {
    return parseInt(this.dataset.variant);
  }

  connectedCallback() {
    this.submitButton.addEventListener("click", this.handleSubmit.bind(this));
  }

  disconnectedCallback() {
    this.submitButton.removeEventListener(
      "click",
      this.handleSubmit.bind(this)
    );
  }

  handleSubmit(event) {
    event.preventDefault();

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");

    if (this.submitButton.querySelector(".loading-overlay__spinner")) {
      this.submitButton
        .querySelector(".loading-overlay__spinner")
        .classList.remove("hidden");
    }

    this.addItemToCart();
  }

  async addItemToCart() {
    let formData = {
      items: [
        {
          id: this.variantId,
          quantity: 1,
        },
      ],
      sections_url: window.location.pathname,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
    };

    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.submitButton.setAttribute("aria-disabled", false);
        this.submitButton.classList.remove("loading");

        if (this.submitButton.querySelector(".loading-overlay__spinner")) {
          this.submitButton
            .querySelector(".loading-overlay__spinner")
            .classList.add("hidden");
        }
        this.cart.renderContents(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("atc-button", AtcButton);

class RelatedSets extends HTMLElement {
  constructor() {
    super();

    this.productTitles = Array.from(this.querySelectorAll(".related_title"));
  }

  connectedCallback() {
    this.setTitleElementHeight = this.setTitleElementHeight.bind(this);
    this.setTitleElementHeight();

    window.addEventListener("resize", this.setTitleElementHeight);
  }

  setTitleElementHeight() {
    if (!this.productTitles.length) return;

    const heights = this.productTitles.map((element) => element.offsetHeight);
    const maxHeight = Math.max(...heights);
    const allEqual = heights.every((height) => height === maxHeight);
    if (!allEqual) {
      this.productTitles.forEach((element) => {
        element.style.height = `${maxHeight}px`;
      });
    }
  }
}

customElements.define("related-sets", RelatedSets);

class CountdownBar extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.startCountdown();
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  startCountdown() {
    const countDownDate = new Date(
      this.getAttribute("data-counter-date")
    ).getTime();

    // Cache elements to avoid redundant queries
    const daysElement = this.querySelector("#countdown-bar-days");
    const hoursElement = this.querySelector("#countdown-bar-hrs");
    const minutesElement = this.querySelector("#countdown-bar-mins");
    const secondsElement = this.querySelector("#countdown-bar-secs");

    // Helper function to ensure double digits
    const formatNumber = (num) => String(num).padStart(2, "0");

    this.interval = setInterval(() => {
      const now = Date.now();
      const distance = Math.max(countDownDate - now, 0);

      const days = Math.floor(distance / 86400000); // 1000 * 60 * 60 * 24
      const hours = Math.floor((distance % 86400000) / 3600000); // 1000 * 60 * 60
      const minutes = Math.floor((distance % 3600000) / 60000); // 1000 * 60
      const seconds = Math.floor((distance % 60000) / 1000);

      daysElement.textContent = formatNumber(days);
      hoursElement.textContent = formatNumber(hours);
      minutesElement.textContent = formatNumber(minutes);
      secondsElement.textContent = formatNumber(seconds);

      if (distance === 0) clearInterval(this.interval);
    }, 1000);
  }
}

customElements.define("countdown-bar", CountdownBar);

class SliderElement extends HTMLElement {
  static get observedAttributes() {
    return ["data-config"];
  }

  constructor() {
    super();
    this.swiper = null;
    this.swiperConfig = this.dataset.config
      ? JSON.parse(this.dataset.config)
      : {};
    this.adjustHeightSelector = this.dataset.adjustSwiperHeight;
    this.resizeTimeout = null;
  }

  connectedCallback() {
    if (!this.swiper) {
      this.initSwiper();
    }

    if (this.adjustHeightSelector) {
      this.adjustElementsHeight();
      window.addEventListener("resize", this.debounceResize.bind(this));
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    window.removeEventListener("resize", this.debounceResize.bind(this));
  }

  initSwiper() {
    this.swiper = new Swiper(this, this.swiperConfig);
  }

  debounceResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.adjustElementsHeight();
    }, 250);
  }

  adjustElementsHeight() {
    if (!this.swiper || !this.adjustHeightSelector) return;

    let maxHeight = 0;
    const elements = this.querySelectorAll(this.adjustHeightSelector);

    elements.forEach((element) => {
      element.style.height = "auto";
    });

    elements.forEach((element) => {
      const elementHeight = element.offsetHeight;
      maxHeight = Math.max(maxHeight, elementHeight);
    });

    elements.forEach((element) => {
      element.style.height = `${maxHeight}px`;
    });

    this.swiper.update();
  }
}

customElements.define("slider-element", SliderElement);
